<template>
  <form>
    <md-card>
      <div style="float:right;margin-top:-18px;">
        <button type="button" class="mybtn btn saved" @click="Savedokument()">
          {{ $t("Сақлаш ва беркитиш") }} <sup>crl+enter</sup>
        </button>
        <router-link class="mybtn btn" :to="{ path: '/malumot/staff/index' }">
          <button type="button" class="closebutton">
            {{ $t("Чиқиш") }}<sup>esc</sup>
          </button>
        </router-link>
      </div>
      <md-card-content>
        
        <div class="md-layout">
          <div class="row">
            <div class="col-md-4">
              <label>{{ $t("Номи") }}</label>
            </div>
            <div class="col-md-8">
              <input class="form-control" ref="focused" v-model="datas.name" type="text" />
            </div>
            <div class="col-md-4">
              <label>{{ $t('Маош') }}</label>
            </div>
            <div class="col-md-8">
              <vue-numeric separator="space" v-bind:precision="0" v-model="datas.salary"
                class="form-control"></vue-numeric>
            </div>
            <div class="col-md-4">
              <label>{{ $t('Бонус') }} %</label>
            </div>
            <div class="col-md-8">
              <vue-numeric separator="space" v-bind:precision="2" v-model="datas.bonus"
                class="form-control"></vue-numeric>
            </div>
            <div class="col-md-4">
              <label>{{ $t("Лавозим") }}</label>
            </div>
            <div class="col-md-8">
              <input class="form-control" ref="focused" v-model="datas.position" type="text" />
            </div>
            <div class="col-md-4">
              <label>{{ $t("Табел рақами") }}</label>
            </div>
            <div class="col-md-8">
              <input class="form-control" ref="focused" v-model="datas.tabel_number" type="text" />
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { print } from "../../../components/mixins/print.js";
import $ from "jquery";
export default {
  name: "StaffForm",
  mixins: [print],
  data() {
    return {
      status: ""
    };
  },
  props: ["datas"],
  created() {
    let self = this;
    self.$root.$refs.staff = self;
  },
  mounted: function () {
    this.Focus();
  },
  methods: {
    Focus() {
      this.$refs.focused.focus();
    },
    Savedokument() {
      let self = this;
      if (this.$route.path == "/malumot/staff/create") {
        var methods = "post";
        var action = "api/v1/staff";
      } else {
        var methods = "patch";
        var action = "api/v1/staff/id/" + self.$route.params.id;
      }
      axios({
        method: methods,
        url: action,
        data: self.datas
      }).then(function (response) {
        self.$store.state.saved = 1;
        self.$router.push({ name: "Staff" });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-dialog .md-dialog-container {
  max-width: 768px;
}
</style>
